import { Check } from '@beamery/lib-ds-icons';
import React from 'react';
import { LabelText, IconContainer } from './checkbox.styles.js';
export const CheckboxDefault = (props) => (React.createElement(React.Fragment, null,
    React.createElement(IconContainer, { isHovered: props.isHovered, isSelected: props.isSelected, isFocusVisible: props.isFocusVisible }, props.isSelected && React.createElement(Check, { size: 'small', color: 'primaryOnDark' })),
    React.createElement(LabelText, { loading: props.isLoading }, props.label)));
//# sourceMappingURL=checkbox-default.component.js.map